export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8001';

export const PLAYLIST_API_PATH = '/api/v1/playlist/';

export const PLAYLIST_CONTENT_API_PATH = '/api/v1/playlist-content/';

// Shorts preset (spec odk-shorts-mrss/1.0) — the reusable shorts-generation spec handed to
// an outside vendor. Backend app `shorts` (ucms-be #918/#984).
export const SHORTS_PRESET_API_PATH = '/api/v1/shorts/presets/';

// Work-order feed. Returns MRSS XML, not JSON, and takes no query parameters —
// the lookback window is fixed at 3 days (spec's rolling 72 hours) server-side.
//
// One feed per playlist: spec §5.3 puts the order at channel level ("one channel =
// one feed = one setting") and at ODK one playlist is one channel. `Playlist.preset`
// supplies the single <odk:order>.
//
// Public endpoint (PlaylistMrssView declares no permission_classes), exactly like the
// amagi/xumo/odk feeds — the vendor polls the URL with no token. Safe as a plain <a> link.
export const buildShortsWorkOrderFeedUrl = (playlistId: number | string): string =>
  `${BASE_URL}${PLAYLIST_API_PATH}${playlistId}/mrss/bebridge`;

export const CONTENT_API_PATH = '/api/v1/content/';
export const REVENUE_API_PATH = '/api/v1/revenues/';

export const DIRECT_UPLOAD_MULTIPART_START_API_PATH =
  '/api/v1/content/direct-upload-multipart/start/';
export const DIRECT_UPLOAD_MULTIPART_COMPLETE_API_PATH =
  '/api/v1/content/direct-upload-multipart/complete/';
export const DIRECT_UPLOAD_MULTIPART_PRESIGNED_URL_API_PATH =
  '/api/v1/content/direct-upload-multipart/pre-signed-url/';

// Vietnam platform key-based multipart upload (file-only, no Video/content record).
// Frontend supplies the S3 `key`; server only validates/normalizes it.
// Backend: app/app/urls.py → 'api/v1/vietnam-upload/' + app/vietnam_upload/urls.py → 'multipart/<action>/'.
// Actual URL: {BASE_URL}/api/v1/vietnam-upload/multipart/<action>/  (trailing slash required).
export const VIETNAM_UPLOAD_MULTIPART_BASE_API_PATH = '/api/v1/vietnam-upload/multipart';

// Company-scoped list of the caller's Vietnam uploads (DB-backed, owner/company enforced server-side).
// Ingest wrapper lives at `{path}{id}/ingest/`.
export const VIETNAM_UPLOAD_LIST_API_PATH = '/api/v1/vietnam-upload/uploads/';

export const VIDEO_SOURCE_API_PATH = '/api/v1/video-source/';

export const VIDEO_STATUS_API_PATH = '/api/v1/content/video-status/';

export const CATEGORY_API_PATH = '/api/v1/category/';
export const TAG_API_PATH = '/api/v1/tags/';

export const SEASON_API_PATH = '/api/v1/season/';

export const SERIES_API_PATH = '/api/v1/series/';

export const SEASON_SUB_PATH = '/seasons/';

export const PEOPLE_API_PATH = '/api/v1/cast/';

export const CONTRACT_API_PATH = '/api/v1/contracts/';

export const CONTRACT_UPLOAD_API_PATH = '/api/v1/contracts/upload/';

export const CONTRACT_EXPORT_API_PATH = '/api/v1/contracts/export/';

export const BULK_EPISODE_JOBS_API_PATH = '/api/v1/mediahold/bulk-episode-jobs/';

export const CONTENT_SUB_PATH = '/contents/';

export const REFRESH_API_PATH = '/api/v1/accounts/token/refresh/';

export const ADMIN_USER_API_PATH = '/api/v1/accounts/admin/users/';

export const USER_API_PATH = '/api/v1/accounts/user/';

export const LOGIN_API_PATH = '/api/v1/accounts/login/';

export const LOGOUT_API_PATH = '/api/v1/accounts/logout/';

export const PROJECT_API_PATH = '/api/v1/projects/';

export const COMPANY_API_PATH = '/api/v1/projects/companies/';

export const PLATFORM_API_PATH = '/api/v1/projects/platforms/';

export const ROLE_API_PATH = '/api/v1/roles/';

export const PERMISSION_API_PATH = '/api/v1/permissions/';

export const ACTION_HISTORY_API_PATH = '/api/v1/history/user-action-history/';

export const GENRE_API_PATH = '/api/v1/genres/';

export const ADDITIONAL_CONTENT_API_PATH = '/api/v1/content/additional-content/';

export const S3_VIDEO_SOURCE_API_PATH = '/api/v1/video-asset/asset-source/';

export const VIDEO_ASSET_API_PATH = '/api/v1/video-asset/videos/';

export const CONTENT_VIDEO_API_PATH = '/api/v1/video-asset/content-video/';

export const VIDEO_SUBTITLE_API_PATH = '/api/v1/video-asset/video-subtitle/';

export const VIDEO_THUMBNAIL_API_PATH = '/api/v1/video-asset/video-thumbnail/';

export const CONTENT_ASSET_API_PATH = '/api/v1/content/video-asset/';

export const TITLE_AUTO_GENERATOR_API_PATH = '/api/v1/title-auto-generator/';

export const KCP_INGEST_API_PATH = '/api/v1/kcp/ingest/';

export const KCP_INFO_API_PATH = '/api/v1/kcp/info/';

export const MEDIAHOLD_INGEST_API_PATH = '/api/v1/mediahold/history/';

export const GLOBAL_SETTING_COUNTRY_API_PATH = '/api/v1/global-setting/countries/';
export const GLOBAL_SETTING_REGION_API_PATH = '/api/v1/global-setting/regions/';
export const GLOBAL_SETTING_LANGUAGE_API_PATH = '/api/v1/global-setting/languages/';
export const GLOBAL_SETTING_DEFAULT_SERVICE_AUTO_DISTRIBUTION_API_PATH =
  '/api/v1/global-setting/default-service-auto-distribution/';

export const MOVIE_API_PATH = '/api/v1/movies/';

export const VIDEO_SYNC_MONITOR_API_PATH = '/api/v1/content/video-sync-monitor/';

export const CONTENT_THUMBNAIL_OVERRIDE_API_PATH = '/api/v1/content/';

export const VENDOR_SEASON_LIST_API_PATH = '/api/v1/vendor/season-list/';
export const VENDOR_SEASON_LIST_BULK_SUB_PATH = '/bulk/';
export const VENDOR_SEASON_LIST_BULK_BY_SEASON_SUB_PATH = '/bulk-by-season/';
export const VENDOR_SEASON_LIST_CONTENTS_SUB_PATH = '/contents/';
export const VENDOR_NOTIFICATION_EMAIL_API_PATH = '/api/v1/vendor/notification-email/';
